import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { TInputField } from "../../../providers/ModernAcquisitionProvider/types";
import { IFieldName } from "../../../providers/Pushdown/util/getPushdownError";

export type TErrorState = 'RequiredField' | 'NotValid' | 'ThirdParty'

export type TFieldValidationResult = {
    [ name in IFieldName ] ?: TErrorState
};

export type TFieldValidationFunction =
    | ((validatingState: TAcquisitionProviderFacade) => (TFieldValidationResult))
    | ((validatingState: TAcquisitionProviderFacade) => (Promise<TFieldValidationResult>));

export const isFieldInvalid = (field: Partial<TInputField>) => field.value && field.state !== 'error';

export class ValidationAbortError extends Error {
    pushdownToShow: string;
    constructor (message: string, pushdownToShow?: string) {
        super(message);
        this.pushdownToShow = pushdownToShow;
    }
};
